import React from "react";
import { Outlet } from "react-router";
import Background from "src/components/Background";
import SplashScreen from "src/components/SplashScreen";

function HomeLayout() {
  return (
    <div className="relative flex flex-col mx-auto h-full min-w-[280px] min-h-[450px] items-center justify-center p-[16px]">
      <SplashScreen />
      <Background />
      <Outlet />
    </div>
  );
}

export default HomeLayout;
